import { useEffect, useState } from "react";
import axios from "../axios";

export default function CampaignHistory() {

  const [data, setData] = useState([]);

  const fetchHistory = async () => {
    try {
      const res = await axios.get("/campaigns/history");

      console.log(res.data); // ✅ यहीं होना चाहिए

      setData(res.data);

    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchHistory();
  }, []);

  return (
    <div className="p-6">

      <h1 className="text-2xl font-bold mb-4">Campaign History</h1>

      {Array.isArray(data) ? (
        <table className="w-full border">
          <thead>
            <tr className="bg-gray-200">
              <th>Name</th>
              <th>Total</th>
              <th>Sent</th>
              <th>Failed</th>
              <th>WA Sent</th>
              <th>Delivered</th>
              <th>Read</th>
              <th>WA Failed</th>
              <th>Status</th>
            </tr>
          </thead>

          <tbody>
            {data.map((c) => (
              <tr key={c.id} className="text-center border-t">
                <td>{c.name}</td>
                <td>{c.total}</td>
                <td>{c.sent}</td>
                <td>{c.failed}</td>
                <td>{c.wa_sent}</td>
                <td>{c.wa_delivered}</td>
                <td>{c.wa_read}</td>
                <td>{c.wa_failed}</td>
                <td>{c.status}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p>No data found</p>
      )}

    </div>
  );
}